<script lang="ts" setup>
import { ref } from 'vue'
import { lang } from '../libs/localization'
import Modal from './Modal.vue'
const emit = defineEmits(['close'])
const submit = () => {
  if (!confirm.value) return
  localStorage.setItem('completedTest', 'true')
  emit('close')
}
const confirm = ref(false)
</script>

<template>
  <Modal @close="$emit('close')">
    <div class="ModalContent">
      <div class="ModalTitle">{{ lang === 'ja' ? 'ご利用にあたり' : 'Before you begin' }}</div>
      <div v-if="lang === 'ja'" class="caution">
        <p>誹謗中傷・荒らし行為は法律に違反します</p>
        <p>発覚した場合、インターネット回線契約者を開示請求のうえ法的措置が取られます</p>
      </div>
      <div v-else class="caution">
        <p>Harassment, abuse, and disruptive behavior are not allowed.</p>
        <p>Violations may result in content removal, account suspension, or other appropriate action.</p>
      </div>
      <div class="confirmation">
        <label>
          <input type="checkbox" v-model="confirm"> {{ lang === 'ja' ? '上記を理解し同意する' : 'I understand and agree' }}
        </label>
      </div>
      <button :class="{ disabled: !confirm }" @click="submit">{{ lang === 'ja' ? '利用開始' : 'Continue' }}</button>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
select {
  margin: 0 4px;
  padding: 4px 6px;
}
button {
  margin-top: 10px;
}
.caution {
  text-align: center;
  margin: 20px 0;
  padding: 5px 10px;
  background-color: transparent;
  border: 2px solid var(--red);
  font-weight: bold;
  font-size: 15px;
  color: var(--red);
}
.confirmation {
  margin-bottom: 17px;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  color: var(--red);
}
</style>
